<!-- landing.component.html -->
<div class="lp">

  <!-- ══════════════════════════════════════════
       NAV
  ══════════════════════════════════════════ -->
  <nav class="lp__nav" [class.lp__nav--scrolled]="scrolled">
    <div class="lp__nav-inner">

      <a class="lp__nav-brand" routerLink="/">
        <div class="lp__nav-logo">
          <img src="assets/images/fieldlogo.png" alt="FieldOps"
               onerror="this.style.display='none';this.nextElementSibling.style.display='flex'"/>
          <div class="lp__nav-logo-fallback">FO</div>
        </div>
        <span class="lp__nav-name">
          Kinex<span class="lp__nav-accent">Ops</span>
        </span>
      </a>

      <div class="lp__nav-links">
        <a class="lp__nav-link" (click)="scrollTo('features')">Features</a>
        <a class="lp__nav-link" (click)="scrollTo('how')">How It Works</a>
        <a class="lp__nav-link" (click)="scrollTo('pricing-section')">Pricing</a>
        <a class="lp__nav-link" (click)="scrollTo('safety-section')">Safety</a>
      </div>

      <div class="lp__nav-cta">
        <a routerLink="/auth/login"
           [queryParams]="{from: 'landing'}"
           class="lp__nav-login">
          Log in
        </a>
        <a routerLink="/auth/register-company" class="lp__nav-register">
          Start Free
        </a>
      </div>

      <!-- Mobile hamburger -->
      <button class="lp__hamburger" (click)="mobileOpen = !mobileOpen"
              [class.lp__hamburger--open]="mobileOpen">
        <span></span><span></span><span></span>
      </button>

    </div>

    <!-- Mobile menu -->
    <div class="lp__mobile-menu" [class.lp__mobile-menu--open]="mobileOpen">
      <a class="lp__mobile-link" (click)="scrollTo('features'); mobileOpen=false">Features</a>
      <a class="lp__mobile-link" (click)="scrollTo('how'); mobileOpen=false">How It Works</a>
      <a class="lp__mobile-link" (click)="scrollTo('pricing-section'); mobileOpen=false">Pricing</a>
      <a class="lp__mobile-link" (click)="scrollTo('safety-section'); mobileOpen=false">Safety</a>
      <a routerLink="/auth/login"
         [queryParams]="{from: 'landing'}"
         class="lp__mobile-link">
        Log in
      </a>
      <a routerLink="/auth/register-company" class="lp__mobile-cta">Start Free →</a>
    </div>
  </nav>

  <!-- ══════════════════════════════════════════
       HERO
  ══════════════════════════════════════════ -->
  <section class="lp__hero">

    <!-- Background grid -->
    <div class="lp__hero-grid"></div>

    <!-- Accent shapes -->
    <div class="lp__hero-shape lp__hero-shape--1"></div>
    <div class="lp__hero-shape lp__hero-shape--2"></div>

    <div class="lp__hero-inner">

      <div class="lp__hero-left">

        <div class="lp__hero-eyebrow">
          <span class="lp__hero-dot"></span>
          Built for Nigerian field operations
        </div>

        <h1 class="lp__hero-title">
          Every worker.<br/>
          Every job.<br/>
          <span class="lp__hero-title-accent">Always tracked.</span>
        </h1>

        <p class="lp__hero-body">
          KinexOps gives construction and field service companies
          a single platform to manage workers, assign jobs, track
          GPS locations in real time, and export compliance reports
          — whether your team is online or offline.
        </p>

        <div class="lp__hero-actions">
          <a routerLink="/auth/register-company" class="lp__hero-btn-primary">
            Start for free
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M13 6L19 12L13 18"
                    stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
          <a routerLink="/pricing" class="lp__hero-btn-ghost">
            View pricing
          </a>
        </div>

        <div class="lp__hero-trust">
          <div class="lp__hero-trust-item">
            <span class="lp__hero-trust-val">No credit card</span>
            <span class="lp__hero-trust-label">required to start</span>
          </div>
          <div class="lp__hero-trust-sep"></div>
          <div class="lp__hero-trust-item">
            <span class="lp__hero-trust-val">Free plan</span>
            <span class="lp__hero-trust-label">forever available</span>
          </div>
          <div class="lp__hero-trust-sep"></div>
          <div class="lp__hero-trust-item">
            <span class="lp__hero-trust-val">Cancel</span>
            <span class="lp__hero-trust-label">anytime</span>
          </div>
        </div>

      </div>

      <div class="lp__hero-right">
        <div class="lp__hero-dashboard">

          <!-- Dashboard mockup -->
          <div class="lp__mockup">

            <!-- Topbar -->
            <div class="lp__mockup-topbar">
              <div class="lp__mockup-brand">FieldOps</div>
              <div class="lp__mockup-topbar-right">
                <div class="lp__mockup-dot lp__mockup-dot--green"></div>
                <span style="font-size:11px; color:#9CA3AF;">Admin User</span>
              </div>
            </div>

            <!-- Stats row -->
            <div class="lp__mockup-stats">
              <div class="lp__mockup-stat">
                <div class="lp__mockup-stat-val">12</div>
                <div class="lp__mockup-stat-label">Active Jobs</div>
              </div>
              <div class="lp__mockup-stat">
                <div class="lp__mockup-stat-val lp__mockup-stat-val--teal">8</div>
                <div class="lp__mockup-stat-label">Online Now</div>
              </div>
              <div class="lp__mockup-stat">
                <div class="lp__mockup-stat-val">247h</div>
                <div class="lp__mockup-stat-label">Logged</div>
              </div>
              <div class="lp__mockup-stat">
                <div class="lp__mockup-stat-val">3</div>
                <div class="lp__mockup-stat-label">Incidents</div>
              </div>
            </div>

            <!-- Map area -->
            <div class="lp__mockup-map">
              <div class="lp__mockup-map-bg">
                <!-- Simulated map grid lines -->
                <div class="lp__mockup-grid"></div>
                <!-- Worker markers -->
                <div class="lp__mockup-marker lp__mockup-marker--1">
                  <div class="lp__mockup-pin lp__mockup-pin--online">EO</div>
                  <div class="lp__mockup-pulse"></div>
                </div>
                <div class="lp__mockup-marker lp__mockup-marker--2">
                  <div class="lp__mockup-pin lp__mockup-pin--online">MK</div>
                  <div class="lp__mockup-pulse"></div>
                </div>
                <div class="lp__mockup-marker lp__mockup-marker--3">
                  <div class="lp__mockup-pin lp__mockup-pin--offline">AJ</div>
                </div>
                <!-- Live badge -->
                <div class="lp__mockup-live">
                  <span class="lp__mockup-live-dot"></span>
                  LIVE
                </div>
              </div>
            </div>

            <!-- Activity row -->
            <div class="lp__mockup-activity">
              <div class="lp__mockup-activity-row">
                <div class="lp__mockup-avatar" style="background:#1F3A5F">EO</div>
                <div class="lp__mockup-activity-text">
                  <span>Emeka Ofor</span> submitted 8h log
                </div>
                <div class="lp__mockup-activity-time">2m ago</div>
              </div>
              <div class="lp__mockup-activity-row">
                <div class="lp__mockup-avatar" style="background:#2BB0A6">MK</div>
                <div class="lp__mockup-activity-text">
                  <span>Musa Kano</span> started Site Inspection
                </div>
                <div class="lp__mockup-activity-time">14m ago</div>
              </div>
            </div>

          </div>

          <!-- Floating badges -->
          <div class="lp__hero-badge lp__hero-badge--1">
            <div class="lp__hero-badge-icon">📍</div>
            <div>
              <div class="lp__hero-badge-title">GPS Tracked</div>
              <div class="lp__hero-badge-sub">Real-time location</div>
            </div>
          </div>

          <div class="lp__hero-badge lp__hero-badge--2">
            <div class="lp__hero-badge-icon">🛡</div>
            <div>
              <div class="lp__hero-badge-title">NUPRC Compliant</div>
              <div class="lp__hero-badge-sub">Export in one click</div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </section>

  <!-- ══════════════════════════════════════════
       LOGOS / SOCIAL PROOF STRIP
  ══════════════════════════════════════════ -->
  <div class="lp__proof">
    <div class="lp__proof-inner">
      <span class="lp__proof-label">Trusted by field teams across Nigeria</span>
      <div class="lp__proof-logos">
        <div class="lp__proof-logo">Construction</div>
        <div class="lp__proof-sep">·</div>
        <div class="lp__proof-logo">Oil & Gas</div>
        <div class="lp__proof-sep">·</div>
        <div class="lp__proof-logo">Telecommunications</div>
        <div class="lp__proof-sep">·</div>
        <div class="lp__proof-logo">Real Estate</div>
        <div class="lp__proof-sep">·</div>
        <div class="lp__proof-logo">Logistics</div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════
       FEATURES
  ══════════════════════════════════════════ -->
  <section class="lp__features" id="features">
    <div class="lp__section-inner">

      <div class="lp__section-header">
        <div class="lp__section-eyebrow">Platform Features</div>
        <h2 class="lp__section-title">
          Everything your field<br/>operation needs
        </h2>
        <p class="lp__section-body">
          One platform that connects your office to your site —
          no paper, no spreadsheets, no guesswork.
        </p>
      </div>

      <div class="lp__features-grid">

        <div class="lp__feature-card lp__feature-card--large">
          <div class="lp__feature-icon lp__feature-icon--navy">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22C12 22 19 14.2 19 9C19 5.1 15.9 2 12 2Z"
                    stroke="currentColor" stroke-width="1.8"/>
              <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.8"/>
            </svg>
          </div>
          <h3 class="lp__feature-title">Real-Time GPS Tracking</h3>
          <p class="lp__feature-desc">
            See exactly where every worker is — live. Workers are tracked
            every 30 seconds via the FieldOps Mobile app. View route
            history, online/offline status, and location timestamps
            all in one live map.
          </p>
          <div class="lp__feature-tag">Works offline too</div>
        </div>

        <div class="lp__feature-card">
          <div class="lp__feature-icon lp__feature-icon--teal">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
              <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </div>
          <h3 class="lp__feature-title">Job Management</h3>
          <p class="lp__feature-desc">
            Create, assign and track jobs from the admin dashboard.
            Workers update job status, log hours worked and upload
            site photos directly from their mobile device.
          </p>
        </div>

        <div class="lp__feature-card">
          <div class="lp__feature-icon lp__feature-icon--amber">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                    stroke="currentColor" stroke-width="1.8"/>
              <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </div>
          <h3 class="lp__feature-title">PDF & Excel Reports</h3>
          <p class="lp__feature-desc">
            Export branded job reports as PDF or Excel with one click.
            Company logo, worker details, photos, hours logged and
            GPS coordinates — all formatted and ready to share.
          </p>
        </div>

        <div class="lp__feature-card">
          <div class="lp__feature-icon lp__feature-icon--teal">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M18 8C18 6.4 17.4 4.8 16.2 3.6C15 2.4 13.5 2 12 2C10.5 2 9 2.4 7.8 3.6C6.6 4.8 6 6.4 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                    stroke="currentColor" stroke-width="1.8"/>
            </svg>
          </div>
          <h3 class="lp__feature-title">Live Notifications</h3>
          <p class="lp__feature-desc">
            Get instant alerts when workers come online, submit
            work logs, or complete jobs. No more calling workers
            to find out what they have done.
          </p>
        </div>

        <div class="lp__feature-card">
          <div class="lp__feature-icon lp__feature-icon--navy">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
              <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <path d="M16 14C19.3 14 22 16.7 22 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.8"/>
            </svg>
          </div>
          <h3 class="lp__feature-title">Worker Management</h3>
          <p class="lp__feature-desc">
            Invite workers by email. They receive login credentials
            automatically and are prompted to set their own password
            on first login. Full audit trail of who did what.
          </p>
        </div>

        <div class="lp__feature-card lp__feature-card--highlight">
          <div class="lp__feature-icon lp__feature-icon--white">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                    stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="lp__feature-title lp__feature-title--white">Safety & EHS Compliance</h3>
          <p class="lp__feature-desc lp__feature-desc--white">
            Workers report incidents from the field. Admins track
            TRIR, Tier 1/2/3 severity, and export NUPRC/OSHA
            compliance reports. Built for Nigerian regulatory standards.
          </p>
          <div class="lp__feature-tag lp__feature-tag--white">Enterprise</div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════
       OFFLINE FIRST CALLOUT
  ══════════════════════════════════════════ -->
  <section class="lp__offline">
    <div class="lp__section-inner">
      <div class="lp__offline-inner">

        <div class="lp__offline-left">
          <div class="lp__offline-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M1 6C1 6 5 2 12 2C19 2 23 6 23 6"
                    stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5 10C5 10 7.5 7.5 12 7.5"
                    stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round"/>
              <line x1="1" y1="1" x2="23" y2="23"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
              <circle cx="12" cy="17" r="2" fill="currentColor"/>
            </svg>
          </div>
          <div class="lp__offline-text">
            <h3 class="lp__offline-title">Works without internet</h3>
            <p class="lp__offline-desc">
              Workers on remote sites with no data coverage can still
              log hours, submit work notes and take photos. Everything
              syncs automatically the moment connectivity returns.
            </p>
          </div>
        </div>

        <div class="lp__offline-right">
          <div class="lp__offline-stat">
            <span class="lp__offline-stat-val">100%</span>
            <span class="lp__offline-stat-label">Offline capable</span>
          </div>
          <div class="lp__offline-stat-sep"></div>
          <div class="lp__offline-stat">
            <span class="lp__offline-stat-val">Auto</span>
            <span class="lp__offline-stat-label">Sync on reconnect</span>
          </div>
          <div class="lp__offline-stat-sep"></div>
          <div class="lp__offline-stat">
            <span class="lp__offline-stat-val">0</span>
            <span class="lp__offline-stat-label">Data lost</span>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════
       HOW IT WORKS
  ══════════════════════════════════════════ -->
  <section class="lp__how" id="how">
    <div class="lp__section-inner">

      <div class="lp__section-header">
        <div class="lp__section-eyebrow">Getting Started</div>
        <h2 class="lp__section-title">Up and running<br/>in minutes</h2>
      </div>

      <div class="lp__steps">

        <div class="lp__step">
          <div class="lp__step-num">01</div>
          <div class="lp__step-line"></div>
          <div class="lp__step-content">
            <h3 class="lp__step-title">Register your company</h3>
            <p class="lp__step-desc">
              Create your FieldOps account with your company name and email.
              No credit card required. Your admin dashboard is ready instantly.
            </p>
          </div>
        </div>

        <div class="lp__step">
          <div class="lp__step-num">02</div>
          <div class="lp__step-line"></div>
          <div class="lp__step-content">
            <h3 class="lp__step-title">Invite your field workers</h3>
            <p class="lp__step-desc">
              Enter each worker's name and email. FieldOps emails them their
              login credentials automatically. They download the mobile app
              and log in — done.
            </p>
          </div>
        </div>

        <div class="lp__step">
          <div class="lp__step-num">03</div>
          <div class="lp__step-line"></div>
          <div class="lp__step-content">
            <h3 class="lp__step-title">Create and assign jobs</h3>
            <p class="lp__step-desc">
              Create a job from the dashboard, assign a worker, set the location.
              The worker sees it instantly on their mobile app.
            </p>
          </div>
        </div>

        <div class="lp__step">
          <div class="lp__step-num">04</div>
          <div class="lp__step-line lp__step-line--hidden"></div>
          <div class="lp__step-content">
            <h3 class="lp__step-title">Track, report, export</h3>
            <p class="lp__step-desc">
              Workers submit logs and photos from site. You track them live
              on the map, monitor job progress, and export reports whenever
              you need them.
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════
       SAFETY SECTION
  ══════════════════════════════════════════ -->
  <section class="lp__safety" id="safety-section">
    <div class="lp__section-inner">
      <div class="lp__safety-inner">

        <div class="lp__safety-left">
          <div class="lp__section-eyebrow lp__section-eyebrow--light">
            EHS Compliance
          </div>
          <h2 class="lp__safety-title">
            NUPRC / OSHA<br/>
            compliance built in
          </h2>
          <p class="lp__safety-desc">
            Workers report incidents from the mobile app — near misses,
            injuries, spills and equipment failures. Your Safety Command
            Center tracks TRIR, severity tiers and investigation status
            in real time.
          </p>

          <div class="lp__safety-bullets">
            <div class="lp__safety-bullet">
              <div class="lp__safety-bullet-icon lp__safety-bullet-icon--green">✓</div>
              <span>Tier 1, 2 and 3 incident classification</span>
            </div>
            <div class="lp__safety-bullet">
              <div class="lp__safety-bullet-icon lp__safety-bullet-icon--green">✓</div>
              <span>TRIR calculation from real work hours</span>
            </div>
            <div class="lp__safety-bullet">
              <div class="lp__safety-bullet-icon lp__safety-bullet-icon--green">✓</div>
              <span>Audit-locked resolved records</span>
            </div>
            <div class="lp__safety-bullet">
              <div class="lp__safety-bullet-icon lp__safety-bullet-icon--green">✓</div>
              <span>NUPRC compliance PDF export</span>
            </div>
            <div class="lp__safety-bullet">
              <div class="lp__safety-bullet-icon lp__safety-bullet-icon--amber">★</div>
              <span>Enterprise plan only</span>
            </div>
          </div>

          <a routerLink="/pricing" class="lp__safety-cta">
            See Enterprise plan
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M13 6L19 12L13 18"
                    stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>

        <div class="lp__safety-right">
          <!-- Safety mockup card -->
          <div class="lp__safety-mockup">

            <div class="lp__safety-mockup-header">
              <span class="lp__safety-mockup-shield">🛡</span>
              <div>
                <div class="lp__safety-mockup-title">Safety Command Center</div>
                <div class="lp__safety-mockup-sub">EHS Dashboard</div>
              </div>
            </div>

            <div class="lp__safety-kpis">
              <div class="lp__safety-kpi">
                <div class="lp__safety-kpi-val">0.82</div>
                <div class="lp__safety-kpi-label">TRIR</div>
              </div>
              <div class="lp__safety-kpi lp__safety-kpi--red">
                <div class="lp__safety-kpi-val">2</div>
                <div class="lp__safety-kpi-label">Tier 3 Critical</div>
              </div>
              <div class="lp__safety-kpi lp__safety-kpi--green">
                <div class="lp__safety-kpi-val">14</div>
                <div class="lp__safety-kpi-label">Resolved</div>
              </div>
            </div>

            <div class="lp__safety-incidents">
              <div class="lp__safety-incident">
                <div class="lp__safety-incident-sev lp__safety-incident-sev--red">T3</div>
                <div class="lp__safety-incident-info">
                  <div class="lp__safety-incident-title">Equipment failure — crane</div>
                  <div class="lp__safety-incident-meta">Lagos • 2 days ago</div>
                </div>
                <div class="lp__safety-incident-status lp__safety-incident-status--amber">
                  Investigating
                </div>
              </div>
              <div class="lp__safety-incident">
                <div class="lp__safety-incident-sev lp__safety-incident-sev--amber">T2</div>
                <div class="lp__safety-incident-info">
                  <div class="lp__safety-incident-title">Near miss — excavation</div>
                  <div class="lp__safety-incident-meta">Abuja • 5 days ago</div>
                </div>
                <div class="lp__safety-incident-status lp__safety-incident-status--green">
                  Resolved
                </div>
              </div>
              <div class="lp__safety-incident">
                <div class="lp__safety-incident-sev lp__safety-incident-sev--green">T1</div>
                <div class="lp__safety-incident-info">
                  <div class="lp__safety-incident-title">Minor cut — scaffolding</div>
                  <div class="lp__safety-incident-meta">PH • 1 week ago</div>
                </div>
                <div class="lp__safety-incident-status lp__safety-incident-status--green">
                  Resolved
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════
       PRICING SECTION (dynamic — same source as /pricing)
  ══════════════════════════════════════════ -->
  <section class="lp__pricing-section" id="pricing-section">
    <div class="lp__section-inner">

      <div class="lp__section-header">
        <div class="lp__section-eyebrow">Pricing</div>
        <h2 class="lp__section-title">
          Start free.<br/>
          Grow on your terms.
        </h2>
        <p class="lp__section-body">
          All plans include the FieldOps Mobile app for your workers.
          Upgrade as your team grows.
        </p>

        <div class="lp__pricing-toggle-wrap">
          <span class="lp__pricing-toggle-label"
                [class.lp__pricing-toggle-label--active]="billingCycle === BillingCycle.Monthly">
            Monthly
          </span>
          <button class="lp__pricing-toggle" (click)="toggleBilling()" aria-label="Toggle billing cycle">
            <span class="lp__pricing-toggle-knob"
                  [class.lp__pricing-toggle-knob--on]="billingCycle === BillingCycle.Annual">
            </span>
          </button>
          <span class="lp__pricing-toggle-label"
                [class.lp__pricing-toggle-label--active]="billingCycle === BillingCycle.Annual">
            Annual
            <span class="lp__pricing-save-badge">Save 2 months</span>
          </span>
        </div>
      </div>

      <!-- Loading state -->
      <div class="lp__pricing-loading" *ngIf="plansLoading">
        <div class="lp__pricing-spinner"></div>
      </div>

      <!-- Plan cards -->
      <div class="lp__pricing-cards" *ngIf="!plansLoading">

        <div class="lp__pricing-card"
             *ngFor="let plan of plans"
             [class.lp__pricing-card--featured]="isPopular(plan.plan)">

          <div class="lp__pricing-featured-badge" *ngIf="isPopular(plan.plan)">
            Most Popular
          </div>

          <div class="lp__pricing-card-top">
            <div class="lp__pricing-plan" [class.lp__pricing-plan--white]="isPopular(plan.plan)">
              {{ plan.plan }}
            </div>

            <div class="lp__pricing-price">
              <span class="lp__pricing-currency" [class.lp__pricing-currency--white]="isPopular(plan.plan)">$</span>
              <span class="lp__pricing-amount" [class.lp__pricing-amount--white]="isPopular(plan.plan)">
                {{ isFree(plan.plan) ? 0 : getMonthlyEquivalent(plan) }}
              </span>
              <span class="lp__pricing-period" [class.lp__pricing-period--white]="isPopular(plan.plan)">/mo</span>
            </div>

            <p class="lp__pricing-tagline"
               [class.lp__pricing-tagline--white]="isPopular(plan.plan)"
               *ngIf="!isFree(plan.plan) && billingCycle === BillingCycle.Annual">
              Billed ${{ plan.priceAnnual }}/year
            </p>
            <p class="lp__pricing-tagline"
               [class.lp__pricing-tagline--white]="isPopular(plan.plan)"
               *ngIf="isFree(plan.plan) || billingCycle === BillingCycle.Monthly">
              {{ isFree(plan.plan) ? 'Perfect to get started' : 'Billed monthly' }}
            </p>
          </div>

          <ul class="lp__pricing-feats">
            <li class="lp__pricing-feat lp__pricing-feat--yes"
                [class.lp__pricing-feat--white]="isPopular(plan.plan)">
             {{ plan.limits.maxWorkers === -1
  ? 'Unlimited workers'
  : plan.limits.maxWorkers + ' workers' }}
            </li>
            <li class="lp__pricing-feat lp__pricing-feat--yes"
                [class.lp__pricing-feat--white]="isPopular(plan.plan)">
           {{ plan.limits.maxActiveJobs === -1
  ? 'Unlimited jobs'
  : 'Up to ' + plan.limits.maxActiveJobs + ' jobs' }}
            </li>
            <li class="lp__pricing-feat"
                [class.lp__pricing-feat--yes]="plan.limits.hasLiveMap"
                [class.lp__pricing-feat--no]="!plan.limits.hasLiveMap"
                [class.lp__pricing-feat--white]="isPopular(plan.plan) && plan.limits.hasLiveMap"
                [class.lp__pricing-feat--white-no]="isPopular(plan.plan) && !plan.limits.hasLiveMap">
              Live Map
            </li>
            <li class="lp__pricing-feat"
                [class.lp__pricing-feat--yes]="plan.limits.hasExcelExport"
                [class.lp__pricing-feat--no]="!plan.limits.hasExcelExport"
                [class.lp__pricing-feat--white]="isPopular(plan.plan) && plan.limits.hasExcelExport"
                [class.lp__pricing-feat--white-no]="isPopular(plan.plan) && !plan.limits.hasExcelExport">
              Excel Export
            </li>
            <li class="lp__pricing-feat"
                [class.lp__pricing-feat--yes]="plan.limits.hasBrandedPdf"
                [class.lp__pricing-feat--no]="!plan.limits.hasBrandedPdf"
                [class.lp__pricing-feat--white]="isPopular(plan.plan) && plan.limits.hasBrandedPdf"
                [class.lp__pricing-feat--white-no]="isPopular(plan.plan) && !plan.limits.hasBrandedPdf">
              Company Branding on PDF
            </li>
            <li class="lp__pricing-feat"
                [class.lp__pricing-feat--yes]="plan.limits.hasReports"
                [class.lp__pricing-feat--no]="!plan.limits.hasReports"
                [class.lp__pricing-feat--white]="isPopular(plan.plan) && plan.limits.hasReports"
                [class.lp__pricing-feat--white-no]="isPopular(plan.plan) && !plan.limits.hasReports">
              Reports &amp; Analytics
            </li>
            <li class="lp__pricing-feat"
                [class.lp__pricing-feat--yes]="plan.limits.hasAiInsights"
                [class.lp__pricing-feat--no]="!plan.limits.hasAiInsights"
                [class.lp__pricing-feat--white]="isPopular(plan.plan) && plan.limits.hasAiInsights"
                [class.lp__pricing-feat--white-no]="isPopular(plan.plan) && !plan.limits.hasAiInsights">
              Predictive Operational Intelligence
            </li>
            <li class="lp__pricing-feat"
                [class.lp__pricing-feat--yes]="plan.limits.hasComplianceExport"
                [class.lp__pricing-feat--no]="!plan.limits.hasComplianceExport"
                [class.lp__pricing-feat--white]="isPopular(plan.plan) && plan.limits.hasComplianceExport"
                [class.lp__pricing-feat--white-no]="isPopular(plan.plan) && !plan.limits.hasComplianceExport">
              NUPRC/OSHA Compliance Export
            </li>
            <li class="lp__pricing-feat lp__pricing-feat--yes"
                [class.lp__pricing-feat--white]="isPopular(plan.plan)">
              {{ plan.limits.supportLevel }} support
            </li>
          </ul>

          <a routerLink="/auth/register-company"
             class="lp__pricing-btn"
             [class.lp__pricing-btn--white]="isPopular(plan.plan)"
             [class.lp__pricing-btn--ghost]="!isPopular(plan.plan)">
            {{ isFree(plan.plan) ? 'Start free' : 'Get ' + plan.plan }}
          </a>
        </div>

      </div>

      <p class="lp__pricing-note">
        All prices shown in USD. Payments processed in Naira via Paystack
        at the current exchange rate. Annual plans save 2 months.
      </p>

    </div>
  </section>

  <!-- ══════════════════════════════════════════
       CTA SECTION
  ══════════════════════════════════════════ -->
  <section class="lp__cta">
    <div class="lp__section-inner">
      <div class="lp__cta-inner">
        <div class="lp__cta-shape-1"></div>
        <div class="lp__cta-shape-2"></div>
        <div class="lp__cta-content">
          <h2 class="lp__cta-title">
            Ready to take control<br/>of your field operations?
          </h2>
          <p class="lp__cta-desc">
            Join construction and field service companies already using
            FieldOps to track workers, manage jobs and stay compliant.
          </p>
          <div class="lp__cta-actions">
            <a routerLink="/auth/register-company" class="lp__cta-btn-primary">
              Create free account
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M13 6L19 12L13 18"
                      stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
            <a routerLink="/pricing" class="lp__cta-btn-ghost">View all plans</a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════
       FOOTER
  ══════════════════════════════════════════ -->
  <footer class="lp__footer">
    <div class="lp__section-inner">
      <div class="lp__footer-inner">

        <div class="lp__footer-brand">
          <div class="lp__footer-logo">
            Kinex<span class="lp__nav-accent">Ops</span>
          </div>
          <p class="lp__footer-tagline">
            Field operations management for Nigerian construction,
            oil & gas and field service companies.
          </p>
        </div>

        <div class="lp__footer-links">
          <div class="lp__footer-col">
            <div class="lp__footer-col-title">Product</div>
            <a class="lp__footer-link" (click)="scrollTo('features')">Features</a>
            <a class="lp__footer-link" routerLink="/pricing">Pricing</a>
            <a class="lp__footer-link" (click)="scrollTo('safety-section')">Safety EHS</a>
            <a class="lp__footer-link" routerLink="/contact">Contact Us</a>
          </div>
          <div class="lp__footer-col">
            <div class="lp__footer-col-title">Account</div>
            <a class="lp__footer-link" routerLink="/auth/login">Log in</a>
            <a class="lp__footer-link" routerLink="/auth/register-company">Register</a>
            <a class="lp__footer-link" routerLink="/pricing">Upgrade plan</a>
            <!-- Add to your landing page footer links -->
            <a class="lp__footer-link" routerLink="/privacy-policy">Privacy Policy</a>
          </div>
        </div>

      </div>

      <div class="lp__footer-bottom">
        <span>© {{ year }} KinexOps. All rights reserved.</span>
        <span>Built for field operations.</span>
      </div>

    </div>
  </footer>

</div>